import Component from '@glimmer/component';
import type { TasAssetExtension as TASAssetModel } from 'tio-data/data/resources/tas-asset.ext';
import type { CustomFieldSignature } from '../../types/tuition-assistance.ts';
import ProgramCustomReadonlyField from './program-custom-readonly-field.gts';
import { t } from 'ember-intl';
import { or } from 'tio-ui/utilities';
interface TuitionAssistanceCustomFieldsApproverReviewSignature {
  Args: {
    assets?: TASAssetModel[];
    customFields?: CustomFieldSignature[];
    province: CustomFieldSignature['province'];
  };
  Element: HTMLElement;
}

export default class TuitionAssistanceCustomFieldsApproverReviewComponent extends Component<TuitionAssistanceCustomFieldsApproverReviewSignature> {
  sortedFields(fields: CustomFieldSignature[], province: CustomFieldSignature['province']) {
    const filtered = fields.filter((field) => field.province === province);
    return filtered.sort((a, b) => a.ordinal - b.ordinal);
  }

  get sortedCustomFieldsByProvince() {
    if (!this.args.customFields) {
      return [];
    }
    return this.sortedFields(this.args.customFields, this.args.province);
  }

  <template>
    {{#if this.sortedCustomFieldsByProvince.length}}
      <div class="my-4">
        <p class="font-semibold mb-1">
          {{t "tuition_assistance.additional_information"}}
        </p>
        <ul>
          {{#each this.sortedCustomFieldsByProvince as |sortedField|}}
            <ProgramCustomReadonlyField @customField={{sortedField}} as |field|>
              <li class="my-2 text-sm">
                <p class="font-semibold">{{t "tuition_assistance.question"}}
                  <span class="font-normal ml-2">
                    {{field.programLabel}}
                  </span>
                </p>
                {{! @glint-expect-error TODO figure out how to properly type these}}
                {{#if (eq field.input "textarea")}}
                  <p class="font-semibold">{{t "tuition_assistance.answer"}}
                    <span class="font-normal ml-1">
                      {{! @glint-expect-error TODO figure out how to properly type these}}
                      {{or field.value (t "tuition_assistance.no_response_provided")}}
                    </span>
                  </p>
                {{else}}
                  <p class="font-semibold">{{t "tuition_assistance.answer"}}
                    <span class="font-normal ml-1">
                      {{! @glint-expect-error TODO figure out how to properly type these}}
                      {{field.value}}
                    </span>
                  </p>
                {{/if}}
              </li>
            </ProgramCustomReadonlyField>
          {{else}}
            <li class="text-sm">{{t "common.none"}}</li>
          {{/each}}
        </ul>
      </div>
    {{/if}}
  </template>
}
